import { Alert } from '@cmsgov/ds-medicare-gov'
import { useTranslation } from 'react-i18next'

type DeleteAccountUnavailableAlertProps = {
  className?: string
}
export function DeleteAccountUnavailableAlert ({
  className
}: DeleteAccountUnavailableAlertProps) {
  const { t } = useTranslation('deleteAccount')

  return <Alert className={className}>{t('errors.elmoOffline')}</Alert>
}

export default DeleteAccountUnavailableAlert
